module.exports = __webpack_public_path__ + "static/img/xi_4.5c1eab4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xi_4.png
// module id = UmkL
// module chunks = 1